var render, staticRenderFns
import script from "./UText.vue?vue&type=script&lang=js&"
export * from "./UText.vue?vue&type=script&lang=js&"
import style0 from "./UText.vue?vue&type=style&index=0&id=3d186560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d186560",
  null
  
)

export default component.exports